<div class=" row mt-3 " style="padding: 10px;">
                         
                          
    <div class="col-md-12 " >
      <div class=" col-md-12 row">
      <mat-form-field class=" col-md-3 mt-1 form-group " >
      <input matInput type="text"   [(ngModel)]="searchText" (input)="searchFilter()"  placeholder="Search..." autocomplete="off"   >
      
      </mat-form-field>
      <div class="col-md-1 mt-3">
     <div class="col-md-12 d-flex justify-content-end">
        <button  class="btn btn-outline-primary btn-sm " (click)="onAddMeal()">
            <img src="assets/images/Add_24.png"></button>
    </div>
      </div>
      <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]"
      [length]="totalElements"
      (page)="nextPage($event)"
      aria-label="Select page">
      </mat-paginator>
      
      </div>
      <div class="col-md-12" style="overflow: auto ;max-height:50vh;">
      <table mat-table 
      [dataSource]="mealData" multiTemplateDataRows style="background-color: transparent;">
     
     
       <ng-container matColumnDef="carrier_code">
         <th mat-header-cell *matHeaderCellDef>Carrier Code</th>
         <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowMealClick(element)"> {{element.carrier_code}} </td>
       </ng-container>
      <ng-container matColumnDef="source_id">
       <th mat-header-cell *matHeaderCellDef> Source </th>
       <td mat-cell *matCellDef="let element"> 
          {{sourceName(element?.source_id)||''}}
         </td>
      </ng-container>
      
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> Type</th>
        <td mat-cell *matCellDef="let element"> {{element?.type}} </td>
       </ng-container>
      <ng-container matColumnDef="meal_code">
        <th mat-header-cell *matHeaderCellDef> Code</th>
        <td mat-cell *matCellDef="let element"> {{element?.meal_code}} </td>
       </ng-container>
       <ng-container  matColumnDef="meal_desc">
        <th mat-header-cell *matHeaderCellDef> Description</th>
        <td mat-cell *matCellDef="let element">
          {{element?.meal_desc}}
           <!-- <button style="background-color: #3389fa;color: white;margin: 4px; " mat-flat-button >GST Detail</button> -->
        </td>
       </ng-container>
     
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container  matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsMealsDisplay.length">
      <div class="example-element-detail row"
       [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
      
      </div>
      </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="columnsMealsDisplay" style="background-color: white;"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsMealsDisplay;"
      class="example-element-row">
      </tr>
      <tr  mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      <tr class="mat-row" *matNoDataRow>
      <td  class="mat-cell" colspan="4">There is no data in this table</td>
      </tr>
      </table>
      
    </div>
      </div>
      
  

</div> 

<div class="modal " id="myMod"  [style.display]="showMealPopup ? 'block' : 'none'" >
    <div class="modal-dialog" >
        <div class="modal-content " >
            <div class="modal-header title" *ngIf="showMealPopup">
              <h4 *ngIf="action==='new'"  class="modal-title">Add Meal</h4>
              <h4 *ngIf="action==='update'"  class="modal-title">Edit Meal</h4>

              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
              </div>
              <div class="modal-body">
              <div class="col-md-12 mt-3 " *ngIf="showMealPopup">
                <div class="col-md-12 d-flex justify-content-center" >
                <div class="col-md-12 row " >
                    <div class=" col-md-12 " >
                        <form    autocomplete="off"  class=" row" >
                            <form [formGroup]="mealRegFg"   autocomplete="off"  class=" row" >
                                <mat-form-field *ngIf="action==='update'" class="col-md-6" appearance="outline">
                                  <mat-label>Carrier Code</mat-label>
                                  <!-- <input matInput type="text" name="carrier_code" readonly formControlName="carrier_code"> -->
                                  <mat-select matNativeControl name="carrierCode" formControlName="carrier_code">
                                    <mat-option *ngFor="let item of carrierCodeList" disabled [value]='item.airlineDesignatorCode'>{{item.carrierName}}</mat-option>

                                  </mat-select> 

                                </mat-form-field>
                                                                         <!-- aria-label="Number" -->

                                <mat-form-field *ngIf="action!='update'" class="col-md-6" appearance="outline">
                                  <mat-label>Carrier Code</mat-label>
                                  <input type="text"
                                         placeholder="Search..."
                                         matInput
                                         [formControl]="myControl"

                                         [matAutocomplete]="auto">
                                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="changeCarrier()">
                                  <mat-option *ngFor="let option of filteredOptions | async;" [value]="option.carrierName+','+option.airlineDesignatorCode">{{option?.carrierName+','+option?.airlineDesignatorCode}}</mat-option>
                                    
                                  </mat-autocomplete>
                                </mat-form-field>

                                <mat-form-field class="col-md-6" appearance="outline">
                                  <mat-label>Source</mat-label>
                                  <mat-select matNativeControl name="source" formControlName="source_id">
                                    <mat-option *ngFor="let item of sourceCodeList" [disabled]="action==='update'" [value]='item.code'>{{item.title}}</mat-option>

                                  </mat-select> 
                                        </mat-form-field>
                                          
                                        
                                
                                <mat-form-field class="col-md-6" appearance="outline">
                                  <mat-label>Meal Code</mat-label>
                                  
                                  <input matInput type="text" [readonly]="action==='update'" formControlName="meal_code" name="meal_code" autocomplete="off">
                                  <small *ngIf="mealRegFg.controls['meal_code'].dirty && mealRegFg.controls['meal_code'].invalid" class="warn">Please Enter Meal Code!</small>

                          
                                </mat-form-field>  
                                <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Meal Description</mat-label>
                                    
                                    <input matInput type="text" formControlName="meal_desc" name="meal_desc" autocomplete="off">
                                    <small *ngIf="mealRegFg.controls['meal_desc'].dirty && mealRegFg.controls['meal_desc'].invalid" class="warn">Please Enter Meal Code!</small>
  
                            
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Domestic Meal Price</mat-label>
                                    
                                    <input matInput type="text" (keypress)="onlyNumberKey($event)" formControlName="dom_meal_price" name="dom_meal_price" autocomplete="off">
                                    <small *ngIf="mealRegFg.controls['dom_meal_price'].dirty && mealRegFg.controls['dom_meal_price'].invalid" class="warn">Please Enter Domestic Meal Price!</small>
  
                            
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Equipment Type</mat-label>
                                    
                                    <input matInput type="text" formControlName="equipment_type" name="equipment_type" autocomplete="off">
                                    <small *ngIf="mealRegFg.controls['equipment_type'].dirty && mealRegFg.controls['equipment_type'].invalid" class="warn">Please Enter Equipment Type!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>International Meal Price</mat-label>
                                    
                                    <input matInput type="text" (keypress)="onlyNumberKey($event)" formControlName="int_meal_price" name="equipment_type" autocomplete="off">
                                    <small *ngIf="mealRegFg.controls['int_meal_price'].dirty && mealRegFg.controls['int_meal_price'].invalid" class="warn">Please Enter International Meal Price!</small>
  
                            
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Minimum Time to Departure</mat-label>
                                    
                                    <input matInput type="text" (keypress)="onlyNumberKey($event)" formControlName="min_time_to_departure" name="min_time_to_departure" autocomplete="off">
                                    <small *ngIf="mealRegFg.controls['min_time_to_departure'].dirty && mealRegFg.controls['min_time_to_departure'].invalid" class="warn">Please Enter Minimum Time to Departure!</small>
  
                            
                                  </mat-form-field>      
                                
                                
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Type</mat-label>
                                    <mat-select matNativeControl name="carrierCode" formControlName="type">
                                      <mat-option  value='M'>Meal</mat-option>
                                      <mat-option  value='S'>Special</mat-option>
                                      <mat-option  value='B'>Baggage</mat-option>

                                    </mat-select> 
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Meal key</mat-label>
                                    
                                    <input matInput type="text"  formControlName="meal_key" name="meal_key" autocomplete="off">
  
                            
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Travel Type</mat-label>
                                    <mat-select matNativeControl name="travel_type" formControlName="travel_type">
                                      <mat-option  value='D'>Domestic</mat-option>
                                      <mat-option  value='I'>International</mat-option>

                                    </mat-select> 
  
                                  </mat-form-field>    
                                </form>
                                </form>
                    </div>
                    </div>
                    </div>                                      
              </div>
                <div class="modal-footer">
                  <div *ngIf="action==='update'" class="col-md-8 d-flex justify-content-start ">
                    <button   class="btn btn-outline-success c-width-100px shadow " (click)="deleteMeal()"  >Delete</button>
                    <!-- <label for="gstlabel" class="col-md-5 col-form-label control-label"> </label> -->

                  </div>   
                  <button *ngIf="action==='update'"  class="btn btn-outline-success c-width-100px shadow " (click)="AddMeal()" [disabled]="mealRegFg.invalid" >Update</button>

                  <button *ngIf="action==='new'"  class="btn btn-outline-success c-width-100px shadow " (click)="AddMeal()" [disabled]="mealRegFg.invalid" >Save</button>
                  <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                </div>
              </div>
              </div>
      </div>
  </div>